import { SelectionModel } from '@angular/cdk/collections';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ArchivoExcel, ColumnaExcel, creaArchivoExcel, RenglonesExcel, TítulosExcel } from 'src/app/core/Funciones/excel';
import { fFecha } from 'src/app/core/Funciones/fFecha';
import { mostrarSwalError, mostrarSwalToast } from 'src/app/core/Funciones/funciones';
import { AccesoDatosService } from 'src/app/core/services/acceso-datos.service';
import { PDFService } from 'src/app/core/services/pdfmake.service';
import { IEmpleados, nombreEmpleado } from 'src/app/models/empleados';
import { IEmpresa } from 'src/app/models/empresa';
import { IHorarios, IHorariosEmpleado, IHorariosTotal } from 'src/app/models/horarios';
import { IRespuestaChecker } from 'src/app/models/resultadoActualiza';
const pdfMake = require('pdfmake/build/pdfmake.js');
const pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-asignar-horarios',
  templateUrl: './asignar-horarios.component.html',
  styleUrls: ['./asignar-horarios.component.scss'],
})
export class AsignarHorariosComponent {
  public empleadosOrigen: IEmpleados[] = [];
  public empleados: IEmpleados[] = [];

  public cargando: boolean = true;
  public filtroGrupo: string | undefined = undefined;
  public filtroArea: string | undefined = undefined;

  public fechaAsignacion: Date = new Date();

  public mensajeError: string | undefined = undefined;
  public mensajeRespuesta: string | undefined = undefined;


  public displayedColumns: string[] = ['select', 'clave', 'nombre', 'rfc', 'area', 'agrupador', 'horario', 'alta', 'baja',];
  public dataSource: MatTableDataSource<IEmpleados> = new MatTableDataSource<IEmpleados>(this.empleados);
  public selection = new SelectionModel<IEmpleados>(true, []);

  public horarioSeleccionado: IHorarios | undefined = undefined;
  public horarios: IHorarios[] = [];

  public horariosEmpleado: IHorariosEmpleado[] = [];
  public empresa!: IEmpresa;
  public etiquetaAgrupar: string = 'Agrupador';
  public empleadosSeleccionados: IEmpleados[] = [];

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private accesoDatosService: AccesoDatosService,
    private paginadoLabel: MatPaginatorIntl,
    private pdfService: PDFService,
  ) {
    this.cargando = true;
    this.paginadoLabel.itemsPerPageLabel = 'Empleados por página';
   }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  public cargarDatos() {
    this.accesoDatosService.empleadosListado().subscribe(
      (empleados: IEmpleados[]) => {
        this.empleadosOrigen = empleados.map(empleado => {
          const horarioActual = this.obtenerHorarioEmpleado(+empleado.id, this.fechaAsignacion);
          return {
            ...empleado,
            horario: horarioActual ? horarioActual.nombreHorario : 'Sin horario',
          };
        });
        this.empleadosOrigen.forEach(empleado => {
          (empleado as any)['nombreCompleto'] = `${empleado.nombre} ${empleado.paterno ? empleado.paterno : ''} ${empleado.materno ? empleado.materno : ''}`;
        });
        this.aplicarFiltros();
        this.cargando = false;
      }, (error) => {
        console.error(error);
        let err: string = error.error;
        this.accesoDatosService.logAgrega2("Error al cargar los horarios. " + err);
        mostrarSwalError('Error', 'Error al cargar los horarios');
      }
    );

    this.accesoDatosService.horarios().subscribe(
      (horarios: IHorarios[]) => {
        this.horarios = horarios;
      }, (error) => {
        console.error(error);
        let err: string = error.error;
        this.accesoDatosService.logAgrega2("Error al cargar los horarios. " + err);
        mostrarSwalError('Error', 'Error al cargar los horarios');
      }
    );

    this.accesoDatosService.horariosEmpleadosConIncidencias().subscribe(
      (horariosTotales: IHorariosTotal) => {
        this.horariosEmpleado = horariosTotales.horariosEmpleados;
      },
      (error: HttpErrorResponse) => {
        mostrarSwalError('Error al cargar el horario', 'Error al cargar el horario del empleado');
        let err: string = JSON.stringify(error);
      }
    );

    this.accesoDatosService.empresaObtener().subscribe(
      (empresa: IEmpresa) => {
        this.empresa = empresa;
        this.etiquetaAgrupar = !empresa.etiquetaGrupo ? 'Agrupador' : empresa.etiquetaGrupo;
      },
      (error: HttpErrorResponse) => {
        let err: string = JSON.stringify(error);
        console.log(err);
      }
    );
  }

  public formatoFecha(fecha: Date | undefined) {
    if (!fecha) {
      return '-';
    }
    return fFecha(fecha, "FSL")
  }

  public nombreCompleto(empleado: IEmpleados){
    return nombreEmpleado(empleado);
  }

  public isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  public masterToggle() {
    this.isAllSelected() ? this.selection.clear() : this.dataSource.data.forEach(row => this.selection.select(row));
  }

  public checkboxLabel(row?: IEmpleados): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
  }


  public incluirEmpleados(empleados: IEmpleados[]) {
    if (!empleados || empleados.length === 0) {
      this.selection.clear();
      return;
    }
    const seleccionadosIds = (empleados || []).map(emp => emp.id);
    const empleadosFiltrados = this.dataSource.data.filter(emp =>
      seleccionadosIds.includes(emp.id)
    );
    this.selection.clear();
    this.selection.select(...empleadosFiltrados);
  }

  public aplicarFiltros() {
    this.empleados = this.empleadosOrigen.filter(x => !x.baja || x.baja.getTime() <= new Date(1900, 1, 1).getTime()).sort(
      (a, b) => +a.numero - +b.numero || a.nombre?.toLowerCase().localeCompare(b.nombre?.toLowerCase())
    );

    // if (!this.filtroGrupo) {
    //   this.empleados = this.empleados.sort((a, b) => a.grupo.toLowerCase().localeCompare(this.filtroGrupo?.toLowerCase()));
    // }

    if (!!this.filtroArea) {
      let filtroArea: string = this.filtroArea.toLowerCase() || '-';
      this.empleados = this.empleados.sort((a, b) => a.area.toLowerCase().localeCompare(filtroArea));
    }

    this.dataSource.data = this.empleados;
  }

  public aplicarCambios() {
    this.cargando = true;
    const fecha = new Date(2024, 0, 1);

    if (this.fechaAsignacion < fecha) {
      mostrarSwalToast(`No puedes asignar el horario con fecha anterior a ${this.formatoFecha(fecha)}`, 'warning');
        return;
    }

    if (!this.horarioSeleccionado || !this.horarioSeleccionado.idHorario) {
      mostrarSwalToast('Selecciona un horario para asignar', 'warning');
      return;
    }

    let idHorario: string = this.horarioSeleccionado.idHorario;

    this.cargando = true;
    let iEmpleados: number = 0;
    let empleadosCargados: string = '';
    // console.log(`aplicarCambios.`);
    this.empleados.forEach(empleado => {
      if (this.selection.isSelected(empleado)) {
        this.accesoDatosService.horarioEmpleadoAsignar(+empleado.id, idHorario, this.fechaAsignacion).subscribe(
          (respuesta: IRespuestaChecker) => {
            let txt: string = ``;
            if (respuesta.code == 100) {
              txt = `Horario: ${this.horarioSeleccionado?.nombreHorario} asignado al empleado: ${nombreEmpleado(empleado)}`;
              mostrarSwalToast(txt, 'success');
              this.cargarDatos();
              this.empleadosSeleccionados = [];
              this.selection.clear();
              this.cargando = false;
            } else {
              txt = `Empleado: ${nombreEmpleado(empleado)}, Respuesta: ${respuesta.code}, ${respuesta.mensaje}`;
              mostrarSwalToast(txt, 'warning');
              empleadosCargados += `, ${txt}`;
              this.cargando = false;
            }
          }, (error) => {
            console.error(error);
            let err: string = error.error;
            this.accesoDatosService.logAgrega2("Error al cargar los horarios. " + err);
            mostrarSwalError('Error', 'Error al cargar los horarios');
            this.cargando = false;
          }
        );
      }
      iEmpleados++;
    });

    // setTimeout(() => {
    //   mostrarSwalToast(`Procesados: ${iEmpleados}${empleadosCargados}`, 'info');
    //   this.cargando = false;
    //   this.selection.clear();
    //   this.horarioSeleccionado = undefined;

    // }, 3000);
  }

  private obtenerHorarioEmpleado(idEmpleado: number, dia: Date): IHorarios | undefined {
    let horarioEmpleado: IHorariosEmpleado | undefined = this.horariosEmpleado.find(x => x.idEmpleado == idEmpleado);
    if (!horarioEmpleado) {
      // console.log(Horarios de TODOS los empleados:, this.horariosEmpleado);
      return undefined;
    }

    return horarioEmpleado.horarios.find(x => x.inicio <= dia && x.fin >= dia);
  }

   public async exportarPDF() {
    try {
      const { empresaImageBase64, logoAcceso } = await this.pdfService.obtenerImg(this.empresa);
      const rows = [];

      const headerRow = [
        { text: 'ID', style: 'tableHeader' },
        { text: 'Nombre empleado', style: 'tableHeader' },
        { text: 'R.F.C.', style: 'tableHeader' },
        { text: 'Área', style: 'tableHeader' },
        { text: 'Horario', style: 'tableHeader' },
        { text: 'Alta', style: 'tableHeader' },
        { text: 'Baja', style: 'tableHeader' },
      ];

      rows.push(headerRow);

      for (const empleado of this.dataSource.data) {
        const dataRow = [
          { text: `${empleado.id}`, style: 'tableCell' },
          { text: `${this.nombreCompleto(empleado)}`, style: 'tableCell' },
          { text: `${empleado.rfc}`, style: 'tableCell' },
          { text: `${empleado.area || '-'}`, style: 'tableCell' },
          { text: `${empleado.horario}`, style: 'tableCell' },
          { text: `${this.formatoFecha(empleado.alta)}`, style: 'tableCell' },
          { text: `${this.formatoFecha(empleado.baja)}`, style: 'tableCell' },
        ];

        rows.push(dataRow);
      }

      const docDefinition = {
        pageOrientation: 'landscape',
        pageSize: 'letter',
        footer: (currentPage: number, pageCount: number) => {
          return {
             image: logoAcceso, width: 50, alignment: 'right',
            // columns: [
            //   { text: `Página ${currentPage} de ${pageCount}`, alignment: 'left', style: 'footer' },
            //   { image: logoNomi, width: 50, alignment: 'right' }
            // ],
            margin: [0, 10, 10, 0],
          };
        },
        content: [
          {
            columns: [
              { image: empresaImageBase64, width: 100, margin: [0, 0, 20, 0] },
              {
                stack: [
                  { text: `Asignación de horarios`, style: 'headerTitle', alignment: 'right' },
                  { text: `Fecha de expedición: ${this.formatoFecha(new Date())}`, style: 'headerDate', alignment: 'right' },
                  { text: this.empresa.nombre, style: 'headerDate', alignment: 'right' },
                  { text: this.empresa.rfc, style: 'headerDate', alignment: 'right' },
                ],
                alignment: 'right'
              }
            ],
            margin: [0, 0, 0, 10]
          },
          {
            table: {
              headerRows: 1,
              widths: ['*', '*', '*', '*', '*', '*', '*'],
              body: rows,
            },
            layout: {
              fillColor: (rowIndex: number) => {
                return (rowIndex === 0) ? '#3498db' : (rowIndex % 2 === 0) ? '#f9f9f9' : '#ffffff';
              },
              hLineWidth: (i: number, node: any) => 0.5,
              vLineWidth: (i: number, node: any) => 0.5,
              hLineColor: (i: number, node: any) => '#bfbfbf',
              vLineColor: (i: number, node: any) => '#bfbfbf',
            },
            margin: [0, 0, 0, 20]
          },
        ],
        styles: {
          headerTitle: { fontSize: 16, bold: true, margin: [0, 0, 0, 10] },
          headerDate: { fontSize: 10, italics: true, margin: [0, 0, 0, 0] },
          footer: { fontSize: 10, italics: true, margin: [0, 0, 0, 10] },
          tableHeader: { bold: true, fontSize: 10, color: '#283593', alignment: 'center', fillColor: '#ffffff', margin: [0, 5, 0, 5] },
          tableCell: { fontSize: 8, alignment: 'center', margin: [0, 5, 0, 5] },
          faltasTabla: { fontSize: 8, alignment: 'center', margin: [0, 5, 0, 5], color: '#dc3545', fillColor: '#f8d7da' }
        }
      };

      const fileName = 'Asignacion_de_horarios.pdf';
      pdfMake.createPdf(docDefinition).download(fileName);
    } catch (error) {
      console.error('Error al generar el PDF', error);
    }
  }

  public async exportarExcel() {
    let títulos: TítulosExcel = {
      titulo1: `Asigación de horarios ${this.empresa.nombre}`,
      titulo2: `Fecha de expedición: ${this.formatoFecha(new Date())}`,
      titulo3: undefined,
      titulo4: undefined
    };

    let columnas: ColumnaExcel[] = [
      { header: 'ID', key: 'id', width: 14, alignment: { vertical: 'middle', horizontal: 'left', wrapText: false } },
      { header: `Nombre empleado`, key: 'empleado', width: 50, alignment: { vertical: 'middle', horizontal: 'left', wrapText: false } },
      { header: 'R.F.C.', key: 'entrada', width: 18, alignment: { vertical: 'middle', horizontal: 'left', wrapText: false } },
      { header: 'Área', key: 'salida', width: 18, alignment: { vertical: 'middle', horizontal: 'left', wrapText: false } },
      { header: 'Horario', key: 'horasTrabajadas', width: 30, alignment: { vertical: 'middle', horizontal: 'left', wrapText: false } },
      { header: 'Alta', key: 'horasExtras', width: 25, alignment: { vertical: 'middle', horizontal: 'left', wrapText: false } },
      { header: 'Baja', key: 'retardos', width: 20, alignment: { vertical: 'middle', horizontal: 'left', wrapText: false } },
    ];

    let títuloColumnas: string[] = columnas.map(columna => columna.header);

    let renglones: RenglonesExcel[] = [];

    for (const empleado of this.dataSource.data) {
      const datosRenglon = [
        empleado.id,
        this.nombreCompleto(empleado),
        empleado.rfc,
        empleado.area || '-',
        empleado.horario,
        this.formatoFecha(empleado.alta),
        this.formatoFecha(empleado.baja),
      ];
      renglones.push({ datos: datosRenglon });
    }

    let totales: string[] = [];

    let datos: ArchivoExcel = {
      nombreArchivo: `${títulos.titulo1}.xlsx`,
      títulos: títulos,
      columnas: columnas,
      títuloColumnas: títuloColumnas,
      renglones: renglones,
      totales: totales,
      fuenteTítulo: undefined,
      fuenteRenglones: undefined,
      fuenteTotales: undefined,
    };

    creaArchivoExcel(datos, 'xxx');
  }

  ngOnInit(): void {
    this.cargarDatos();
  }

}
